module.exports = __webpack_public_path__ + "img/jp.723b76b6.jpg";